// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page_IntroductionBox__ztyBm img {
    width: 65px;
    height: 65px;
    margin-top: 133px;
}
.landing-page_IntroductionBox__ztyBm h1 {
    font-size: 16px;
    margin-top: 20px;
    font-weight: bold;
}
.landing-page_IntroductionBox__ztyBm p {
    font-size: 14px;
    margin-top: 10px;
    font-weight: bold;
}

.landing-page_ServicesBox__yOiI1 img {
    width: 290px;
    height: 355px;
    margin-top: 63px;
    border-top-left-radius: 300px;
    border-top-right-radius: 300px;
}
.landing-page_ServicesBox__yOiI1 button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    border-radius: 100px;
    margin: 50px auto 0 auto;
}
.landing-page_ServicesBox__yOiI1 button p {
    margin: 0%;
    font-size: 12px;
    color: #111A00;
    font-family: "Gothic";
}
.landing-page_ServicesBox__yOiI1 div {
    display: none;
}

.landing-page_ServicesBoxFrame__iggPn {
    margin-top: 20px;
    scroll-margin-top: 150px;
}

.landing-page_PlantsButtonBox__uPTSx button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    margin-top: 50px;
    border-radius: 100px;
    direction: ltr;
}
.landing-page_PlantsButtonBox__uPTSx button div {
    width: 70px;
    height: 18px;
    display: flex;
    cursor: pointer;
    flex-wrap: wrap;
    border-radius: 50px;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
    background-color: #191A17;
}
.landing-page_PlantsButtonBox__uPTSx button div:lang(fa) {
    margin-left: 7px;
}
.landing-page_PlantsButtonBox__uPTSx button div:hover {
    transform: translateY(-4px);
}
.landing-page_PlantsButtonBox__uPTSx button div p {
    font-size: 10px;
    color: #AAFF00;
    font-weight: 400;
    position: relative;
    margin: 0 !important;
    font-family: "Gothic";
}
.landing-page_PlantsButtonBox__uPTSx button p {
    margin: 0%;
    font-size: 12px;
    margin-top: 0px;
    color: #111A00;
    position: absolute;
    text-align: center;
    margin-left: 158px;
    font-family: "Gothic";
}

.landing-page_PlantsBox__kWGsV {
    margin-top: 20px;
}

.landing-page_ProjctsButtonBox__jnxfl button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    margin-top: 50px;
    border-radius: 100px;
    direction: ltr;
}
.landing-page_ProjctsButtonBox__jnxfl button div {
    width: 70px;
    height: 18px;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    align-items: center;
    border-radius: 50px;
    justify-content: center;
    transition: transform 0.3s;
    background-color: #191A17;
}
.landing-page_ProjctsButtonBox__jnxfl button div:lang(fa) {
    margin-left: 7px;
}
.landing-page_ProjctsButtonBox__jnxfl button div:hover {
    transform: translateY(-4px);
}
.landing-page_ProjctsButtonBox__jnxfl button div p:lang(fa) {
    font-size: 10px;
    color: #AAFF00;
    font-weight: 400;
    position: relative;
    margin: 0 !important;
    font-family: "Gothic";
}
.landing-page_ProjctsButtonBox__jnxfl button div p:lang(en) {
    font-size: 10px;
    color: #AAFF00;
    font-weight: 400;
    position: relative;
    margin: 0 !important;
    font-family: "Gothic";
}
.landing-page_ProjctsButtonBox__jnxfl button p:lang(fa) {
    margin: 0%;
    font-size: 12px;
    margin-top: 0px;
    color: #111A00;
    position: absolute;
    text-align: center;
    margin-left: 128px;
    font-family: "Gothic";
}
.landing-page_ProjctsButtonBox__jnxfl button p:lang(en) {
    margin: 0%;
    font-size: 12px;
    margin-top: 0px;
    color: #111A00;
    position: absolute;
    text-align: center;
    margin-left: 152px;
}

.landing-page_ProjectsTittleBox__tQ9fF {
    margin-top: 20px;
}

.landing-page_ProjectsPictureBox__AeOZd {
    margin-top: 20px;
}

.landing-page_GreenJournalBox__h6Ygk button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    margin-top: 50px;
    border-radius: 100px;
}
.landing-page_GreenJournalBox__h6Ygk button p {
    margin: 0%;
    font-size: 12px;
    color: #111A00;
    font-family: "Gothic";
}

.landing-page_GreenJournalInfoBox__O6bPE {
    width: 100%;
    height: 200px;
    max-width: 350px;
    overflow: hidden;
    margin-top: 20px;
    text-align: right;
    border-radius: 10px;
    vertical-align: top;
    display: inline-block;
    float: none !important;
    background-color: #24261F;
    border-top-left-radius: 30px;
    border-top-right-radius: 0px;
}
.landing-page_GreenJournalInfoBox__O6bPE p {
    font-size: 10px;
    text-align: left;
    margin-left: 5px;
}

.landing-page_GreenJournalBoxHeader__6sTjL {
    height: 60px;
    background-color: #474D3D;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.landing-page_StoryBox__GDuoh {
    width: 40px;
    height: 40px;
    overflow: hidden;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid #D6E5B8;
}

.landing-page_GreenJournalBoxHeaderTextAndSlideBox__T-22g {
    float: left !important;
}
.landing-page_GreenJournalBoxHeaderTextAndSlideBox__T-22g p {
    font-size: 11px;
    margin-top: 25px;
    text-align: center;
}

.landing-page_no_content_text__wHrUD {
    font-size: 11px;
    margin-top: 25px;
    text-align: center !important;
}

.landing-page_SlideShapeButton__Db3\\+q {
    width: 14px;
    height: 14px;
    margin-top: 25px;
    transform: rotate(-90deg);
    background-color: #85995C;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.landing-page_about_barge_sabz_box__iJrQE {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.landing-page_about_barge_sabz_box__iJrQE img {
    width: 100%;
    height: 92px;
    max-width: 350px;
    border-radius: 10px;
    margin-bottom: -15px;
}
.landing-page_about_barge_sabz_header_box__SXVjB button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    margin-top: 50px;
    margin-bottom: 20px;
    border-radius: 100px;
}
.landing-page_about_barge_sabz_header_box__SXVjB button p {
    margin: 0%;
    font-size: 12px;
    color: #111A00;
    font-family: "Gothic";
}

.landing-page_about_barge_sabz_tittle_box__II\\+C4 button {
    width: 200px;
    height: 25px;
    position: relative;
    border-radius: 50px;
    background-color: #474D3D;
}
.landing-page_about_barge_sabz_tittle_box__II\\+C4 button p {
    margin: 0%;
    font-size: 10px;
    color: #FFFFFF;
}

.landing-page_about_barge_sabz_body_box__aCoU6 {
    width: 100%;
    height: 92px;
    max-width: 350px;
    margin-top: -10px;
    border-radius: 10px;
    border: 1px solid #D6E5B8;
    background-color: #191A17;
}
.landing-page_about_barge_sabz_body_box__aCoU6 p {
    margin: 0%;
    font-size: 10px;
    margin-top: 24px;
    color: #FFFFFF;
}

.landing-page_contact_us_box__udSGp {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.landing-page_contact_us_header_box__SS48q button {
    width: 100%;
    height: 30px;
    cursor: auto;
    max-width: 350px;
    margin-top: 50px;
    margin-bottom: 20px;
    border-radius: 100px;
}
.landing-page_contact_us_header_box__SS48q button p {
    margin: 0%;
    font-size: 12px;
    color: #111A00;
    font-family: "Gothic";
}

.landing-page_contact_id_box__PLtsS {
    width: 135px;
    height: 25px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 7px;
    margin-left: 53px;
    position: absolute;
    align-items: center;
    border-radius: 50px;
    justify-content: center;
    background-color: #474D3D;
}
.landing-page_contact_id_box__PLtsS p {
    margin: 0%;
    font-size: 10px;
    color: #FFFFFF;
}

.landing-page_contact_icon_box__OEKH3 {
    width: 100px;
    height: 40px;
    overflow: hidden;
    margin-left: 20px;
    border-radius: 50px;
    float: left !important;
    border: 1px solid #D6E5B8;
}
.landing-page_contact_icon_box__OEKH3 img {
    width: 20px;
    float: left;
    height: 20px;
    margin-top: 10px;
    /* margin-left: 8px; */
    margin-left: 12%;
}

.landing-page_services_button_box__EhPNY {
    display: none;
}

.landing-page_email_text__Zatu1 {
    font-size: 8px !important;
}

.landing-page_email_icon__BIZCZ {
    width: 18px !important;
    height: 18px !important;
}

@media (min-width: 1200px) {
    .landing-page_header_box__xE66y div {
        width: 50%;
        height: 684px;
        height: 764px;
        border-bottom: 5px solid #ADB2A1;
    }

    .landing-page_ServicesBox__yOiI1 img {
        width: 100%;
        float: left;
        height: 550px;
        max-width: 450px;
        margin-left: 55px;
        margin-top: 214px;
    }
    .landing-page_ServicesBox__yOiI1 button {
        display: none;
    }
    .landing-page_ServicesBox__yOiI1 div {
        top: 25px;
        width: 100%;
        z-index: -2;
        height: 603px;
        display: flex;
        max-width: 450px;
        position: absolute;
        margin-left: 270px;
        transform: rotate(180deg);
        border: 5px solid #ADB2A1;
        border-top-left-radius: 300px;
        border-top-right-radius: 300px;
    }

    .landing-page_IntroductionBox__ztyBm img {
        width: 130px;
        height: 130px;
        margin-top: 288px;
    }
    .landing-page_IntroductionBox__ztyBm h1 {
        font-size: 30px;
        margin-top: 23px;

    }
    .landing-page_IntroductionBox__ztyBm p {
        font-size: 25px;
        margin-top: 15px;
    }

    .landing-page_services_button_box__EhPNY {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
    .landing-page_services_button_box__EhPNY button {
        width: 100%;
        height: 80px;
        cursor: auto;
        font-size: 30px;
        max-width: 1340px;
        margin-top: 100px;
        margin-bottom: 50px;
        border-radius: 100px;
        font-family: "Gothic";
        background-color: #7B8073;
    }

    .landing-page_PlantsButtonBox__uPTSx button {
        height: 80px;
        max-width: 1340px;
        margin-bottom: 50px;
    }
    .landing-page_PlantsButtonBox__uPTSx button div {
        width: 100%;
        height: 40px;
        display: flex;
        flex-wrap: wrap;
        max-width: 150px;
        margin-right: 25px;
        align-items: center;
        justify-content: center;
    }
    .landing-page_PlantsButtonBox__uPTSx button div:lang(fa) {
        margin-left: 25px;
    }
    .landing-page_PlantsButtonBox__uPTSx button div p {
        font-size: 20px;
    }
    .landing-page_PlantsButtonBox__uPTSx button p {
        font-size: 30px;
        margin-left: 627px;
    }

    .landing-page_ProjctsButtonBox__jnxfl button {
        height: 80px;
        max-width: 1340px;
        margin-top: 50px;
        border-radius: 100px;
    }
    .landing-page_ProjctsButtonBox__jnxfl button div {
        width: 100%;
        height: 40px;
        display: flex;
        flex-wrap: wrap;
        max-width: 150px;
        margin-right: 25px;
        align-items: center;
        justify-content: center;
    }
    .landing-page_ProjctsButtonBox__jnxfl button div:lang(fa) {
        margin-left: 25px;
    }
    .landing-page_ProjctsButtonBox__jnxfl button div p {
        font-size: 20px;
    }
    .landing-page_ProjctsButtonBox__jnxfl button p {
        margin-top: 0;
        font-size: 30px;
        margin-left: 536px;
    }

    .landing-page_ProjectsTittleBox__tQ9fF {
        margin-top: 50px;
        margin-bottom: 50px;
    }

    .landing-page_GreenJournalBox__h6Ygk button {
        width: 100%;
        height: 80px;
        margin-top: 100px;
        max-width: 1340px;
    }
    .landing-page_GreenJournalBox__h6Ygk button p {
        font-size: 30px;
    }

    .landing-page_GreenJournalInfoBox__O6bPE {
        width: 100%;
        height: 500px;
        overflow: hidden;
        margin-top: 50px;
        max-width: 1140px;
        text-align: right;
        border-radius: 30px;
        vertical-align: top;
        display: inline-block;
        float: none !important;
        border-top-left-radius: 50px;
        border-top-right-radius: 0px;
    }
    .landing-page_GreenJournalInfoBox__O6bPE p {
        font-size: 30px;
        margin-left: 50px;
    }

    .landing-page_GreenJournalBoxHeader__6sTjL {
        height: 150px;
        border-top-left-radius: 50px;
        border-bottom-right-radius: 50px;
    }

    .landing-page_StoryBox__GDuoh {
        width: 100px;
        height: 100px;
        overflow: hidden;
        margin-top: 20px;
        margin-right: 30px;
        border: 3px solid #D6E5B8;
    }

    .landing-page_SlideShapeButton__Db3\\+q {
        width: 40px;
        height: 40px;
        margin-top: 55px;
    }

    .landing-page_GreenJournalBoxHeaderTextAndSlideBox__T-22g p {
        font-size: 40px;
        margin-top: 53px;
    }

    .landing-page_no_content_text__wHrUD {
        font-size: 40px;
        margin-top: 53px;
    }

    .landing-page_about_barge_sabz_header_box__SXVjB button {
        height: 80px;
        margin-top: 100px;
        max-width: 1340px;
        margin-bottom: 50px;
    }
    .landing-page_about_barge_sabz_header_box__SXVjB button p {
        font-size: 30px;
    }

    .landing-page_about_barge_sabz_box__iJrQE img {
        width: 100%;
        height: 300px;
        max-width: 1140px;
        border-radius: 30px;
        margin-bottom: -30px;
    }

    .landing-page_about_barge_sabz_tittle_box__II\\+C4 button {
        width: 100%;
        height: 80px;
        max-width: 700px;
        position: relative;
        border-radius: 100px;
    }
    .landing-page_about_barge_sabz_tittle_box__II\\+C4 button p {
        font-size: 30px;   
    }

    .landing-page_about_barge_sabz_body_box__aCoU6 {
        width: 100%;
        height: 300px;
        margin-top: -30px;
        max-width: 1140px;
        border-radius: 30px;
        border: 3px solid #D6E5B8;
    }
    .landing-page_about_barge_sabz_body_box__aCoU6 p {
        font-size: 29px;
        margin-top: 70px;
    }

    .landing-page_contact_us_header_box__SS48q button {
        width: 100%;
        height: 80px;
        margin-top: 50px;
        max-width: 1340px;
        margin-bottom: 50px;
    }
    .landing-page_contact_us_header_box__SS48q button p {
        font-size: 30px;
    }

    .landing-page_contact_icon_box__OEKH3 {
        width: 100%;
        height: 130px;
        max-width: 320px;
        margin-left: 50px;
        border-radius: 100px;
        float: left !important;
        border: 1px solid #D6E5B8;
    }
    .landing-page_contact_icon_box__OEKH3 img {
        width: 70px;
        float: left;
        height: 70px;
        margin-top: 30px;
        margin-left: 30px;
    }

    .landing-page_email_icon__BIZCZ {
        width: 60px !important;
        height: 60px !important;
    }

    .landing-page_contact_id_box__PLtsS {
        width: 100%;
        height: 70px;
        max-width: 450px;
        margin-top: 30px;
        margin-left: 140px;
        border-radius: 100px;
    }
    .landing-page_contact_id_box__PLtsS p {
        font-size: 30px;
        color: #FFFFFF;
    }

    .landing-page_email_text__Zatu1 {
        font-size: 28px !important;
    }

    .landing-page_ServicesBoxFrame__iggPn {
        scroll-margin-top: 300px;
    }

    .landing-page_about_barge_sabz_header_box__SXVjB {
        scroll-margin-top: 110px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/landing-page/landing-page.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;AAC5B;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU;QACV,aAAa;QACb,aAAa;QACb,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,aAAa;QACb,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;;IAEpB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,4BAA4B;QAC5B,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".IntroductionBox img {\r\n    width: 65px;\r\n    height: 65px;\r\n    margin-top: 133px;\r\n}\r\n.IntroductionBox h1 {\r\n    font-size: 16px;\r\n    margin-top: 20px;\r\n    font-weight: bold;\r\n}\r\n.IntroductionBox p {\r\n    font-size: 14px;\r\n    margin-top: 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.ServicesBox img {\r\n    width: 290px;\r\n    height: 355px;\r\n    margin-top: 63px;\r\n    border-top-left-radius: 300px;\r\n    border-top-right-radius: 300px;\r\n}\r\n.ServicesBox button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    border-radius: 100px;\r\n    margin: 50px auto 0 auto;\r\n}\r\n.ServicesBox button p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    color: #111A00;\r\n    font-family: \"Gothic\";\r\n}\r\n.ServicesBox div {\r\n    display: none;\r\n}\r\n\r\n.ServicesBoxFrame {\r\n    margin-top: 20px;\r\n    scroll-margin-top: 150px;\r\n}\r\n\r\n.PlantsButtonBox button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    margin-top: 50px;\r\n    border-radius: 100px;\r\n    direction: ltr;\r\n}\r\n.PlantsButtonBox button div {\r\n    width: 70px;\r\n    height: 18px;\r\n    display: flex;\r\n    cursor: pointer;\r\n    flex-wrap: wrap;\r\n    border-radius: 50px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: transform 0.3s;\r\n    background-color: #191A17;\r\n}\r\n.PlantsButtonBox button div:lang(fa) {\r\n    margin-left: 7px;\r\n}\r\n.PlantsButtonBox button div:hover {\r\n    transform: translateY(-4px);\r\n}\r\n.PlantsButtonBox button div p {\r\n    font-size: 10px;\r\n    color: #AAFF00;\r\n    font-weight: 400;\r\n    position: relative;\r\n    margin: 0 !important;\r\n    font-family: \"Gothic\";\r\n}\r\n.PlantsButtonBox button p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    margin-top: 0px;\r\n    color: #111A00;\r\n    position: absolute;\r\n    text-align: center;\r\n    margin-left: 158px;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.PlantsBox {\r\n    margin-top: 20px;\r\n}\r\n\r\n.ProjctsButtonBox button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    margin-top: 50px;\r\n    border-radius: 100px;\r\n    direction: ltr;\r\n}\r\n.ProjctsButtonBox button div {\r\n    width: 70px;\r\n    height: 18px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    cursor: pointer;\r\n    align-items: center;\r\n    border-radius: 50px;\r\n    justify-content: center;\r\n    transition: transform 0.3s;\r\n    background-color: #191A17;\r\n}\r\n.ProjctsButtonBox button div:lang(fa) {\r\n    margin-left: 7px;\r\n}\r\n.ProjctsButtonBox button div:hover {\r\n    transform: translateY(-4px);\r\n}\r\n.ProjctsButtonBox button div p:lang(fa) {\r\n    font-size: 10px;\r\n    color: #AAFF00;\r\n    font-weight: 400;\r\n    position: relative;\r\n    margin: 0 !important;\r\n    font-family: \"Gothic\";\r\n}\r\n.ProjctsButtonBox button div p:lang(en) {\r\n    font-size: 10px;\r\n    color: #AAFF00;\r\n    font-weight: 400;\r\n    position: relative;\r\n    margin: 0 !important;\r\n    font-family: \"Gothic\";\r\n}\r\n.ProjctsButtonBox button p:lang(fa) {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    margin-top: 0px;\r\n    color: #111A00;\r\n    position: absolute;\r\n    text-align: center;\r\n    margin-left: 128px;\r\n    font-family: \"Gothic\";\r\n}\r\n.ProjctsButtonBox button p:lang(en) {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    margin-top: 0px;\r\n    color: #111A00;\r\n    position: absolute;\r\n    text-align: center;\r\n    margin-left: 152px;\r\n}\r\n\r\n.ProjectsTittleBox {\r\n    margin-top: 20px;\r\n}\r\n\r\n.ProjectsPictureBox {\r\n    margin-top: 20px;\r\n}\r\n\r\n.GreenJournalBox button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    margin-top: 50px;\r\n    border-radius: 100px;\r\n}\r\n.GreenJournalBox button p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    color: #111A00;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.GreenJournalInfoBox {\r\n    width: 100%;\r\n    height: 200px;\r\n    max-width: 350px;\r\n    overflow: hidden;\r\n    margin-top: 20px;\r\n    text-align: right;\r\n    border-radius: 10px;\r\n    vertical-align: top;\r\n    display: inline-block;\r\n    float: none !important;\r\n    background-color: #24261F;\r\n    border-top-left-radius: 30px;\r\n    border-top-right-radius: 0px;\r\n}\r\n.GreenJournalInfoBox p {\r\n    font-size: 10px;\r\n    text-align: left;\r\n    margin-left: 5px;\r\n}\r\n\r\n.GreenJournalBoxHeader {\r\n    height: 60px;\r\n    background-color: #474D3D;\r\n    border-top-left-radius: 20px;\r\n    border-bottom-right-radius: 20px;\r\n}\r\n\r\n.StoryBox {\r\n    width: 40px;\r\n    height: 40px;\r\n    overflow: hidden;\r\n    margin-top: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 50%;\r\n    border: 1px solid #D6E5B8;\r\n}\r\n\r\n.GreenJournalBoxHeaderTextAndSlideBox {\r\n    float: left !important;\r\n}\r\n.GreenJournalBoxHeaderTextAndSlideBox p {\r\n    font-size: 11px;\r\n    margin-top: 25px;\r\n    text-align: center;\r\n}\r\n\r\n.no_content_text {\r\n    font-size: 11px;\r\n    margin-top: 25px;\r\n    text-align: center !important;\r\n}\r\n\r\n.SlideShapeButton {\r\n    width: 14px;\r\n    height: 14px;\r\n    margin-top: 25px;\r\n    transform: rotate(-90deg);\r\n    background-color: #85995C;\r\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n}\r\n\r\n.about_barge_sabz_box {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.about_barge_sabz_box img {\r\n    width: 100%;\r\n    height: 92px;\r\n    max-width: 350px;\r\n    border-radius: 10px;\r\n    margin-bottom: -15px;\r\n}\r\n.about_barge_sabz_header_box button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    margin-top: 50px;\r\n    margin-bottom: 20px;\r\n    border-radius: 100px;\r\n}\r\n.about_barge_sabz_header_box button p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    color: #111A00;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.about_barge_sabz_tittle_box button {\r\n    width: 200px;\r\n    height: 25px;\r\n    position: relative;\r\n    border-radius: 50px;\r\n    background-color: #474D3D;\r\n}\r\n.about_barge_sabz_tittle_box button p {\r\n    margin: 0%;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.about_barge_sabz_body_box {\r\n    width: 100%;\r\n    height: 92px;\r\n    max-width: 350px;\r\n    margin-top: -10px;\r\n    border-radius: 10px;\r\n    border: 1px solid #D6E5B8;\r\n    background-color: #191A17;\r\n}\r\n.about_barge_sabz_body_box p {\r\n    margin: 0%;\r\n    font-size: 10px;\r\n    margin-top: 24px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.contact_us_box {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.contact_us_header_box button {\r\n    width: 100%;\r\n    height: 30px;\r\n    cursor: auto;\r\n    max-width: 350px;\r\n    margin-top: 50px;\r\n    margin-bottom: 20px;\r\n    border-radius: 100px;\r\n}\r\n.contact_us_header_box button p {\r\n    margin: 0%;\r\n    font-size: 12px;\r\n    color: #111A00;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.contact_id_box {\r\n    width: 135px;\r\n    height: 25px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 7px;\r\n    margin-left: 53px;\r\n    position: absolute;\r\n    align-items: center;\r\n    border-radius: 50px;\r\n    justify-content: center;\r\n    background-color: #474D3D;\r\n}\r\n.contact_id_box p {\r\n    margin: 0%;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.contact_icon_box {\r\n    width: 100px;\r\n    height: 40px;\r\n    overflow: hidden;\r\n    margin-left: 20px;\r\n    border-radius: 50px;\r\n    float: left !important;\r\n    border: 1px solid #D6E5B8;\r\n}\r\n.contact_icon_box img {\r\n    width: 20px;\r\n    float: left;\r\n    height: 20px;\r\n    margin-top: 10px;\r\n    /* margin-left: 8px; */\r\n    margin-left: 12%;\r\n}\r\n\r\n.services_button_box {\r\n    display: none;\r\n}\r\n\r\n.email_text {\r\n    font-size: 8px !important;\r\n}\r\n\r\n.email_icon {\r\n    width: 18px !important;\r\n    height: 18px !important;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .header_box div {\r\n        width: 50%;\r\n        height: 684px;\r\n        height: 764px;\r\n        border-bottom: 5px solid #ADB2A1;\r\n    }\r\n\r\n    .ServicesBox img {\r\n        width: 100%;\r\n        float: left;\r\n        height: 550px;\r\n        max-width: 450px;\r\n        margin-left: 55px;\r\n        margin-top: 214px;\r\n    }\r\n    .ServicesBox button {\r\n        display: none;\r\n    }\r\n    .ServicesBox div {\r\n        top: 25px;\r\n        width: 100%;\r\n        z-index: -2;\r\n        height: 603px;\r\n        display: flex;\r\n        max-width: 450px;\r\n        position: absolute;\r\n        margin-left: 270px;\r\n        transform: rotate(180deg);\r\n        border: 5px solid #ADB2A1;\r\n        border-top-left-radius: 300px;\r\n        border-top-right-radius: 300px;\r\n    }\r\n\r\n    .IntroductionBox img {\r\n        width: 130px;\r\n        height: 130px;\r\n        margin-top: 288px;\r\n    }\r\n    .IntroductionBox h1 {\r\n        font-size: 30px;\r\n        margin-top: 23px;\r\n\r\n    }\r\n    .IntroductionBox p {\r\n        font-size: 25px;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .services_button_box {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .services_button_box button {\r\n        width: 100%;\r\n        height: 80px;\r\n        cursor: auto;\r\n        font-size: 30px;\r\n        max-width: 1340px;\r\n        margin-top: 100px;\r\n        margin-bottom: 50px;\r\n        border-radius: 100px;\r\n        font-family: \"Gothic\";\r\n        background-color: #7B8073;\r\n    }\r\n\r\n    .PlantsButtonBox button {\r\n        height: 80px;\r\n        max-width: 1340px;\r\n        margin-bottom: 50px;\r\n    }\r\n    .PlantsButtonBox button div {\r\n        width: 100%;\r\n        height: 40px;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        max-width: 150px;\r\n        margin-right: 25px;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .PlantsButtonBox button div:lang(fa) {\r\n        margin-left: 25px;\r\n    }\r\n    .PlantsButtonBox button div p {\r\n        font-size: 20px;\r\n    }\r\n    .PlantsButtonBox button p {\r\n        font-size: 30px;\r\n        margin-left: 627px;\r\n    }\r\n\r\n    .ProjctsButtonBox button {\r\n        height: 80px;\r\n        max-width: 1340px;\r\n        margin-top: 50px;\r\n        border-radius: 100px;\r\n    }\r\n    .ProjctsButtonBox button div {\r\n        width: 100%;\r\n        height: 40px;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        max-width: 150px;\r\n        margin-right: 25px;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .ProjctsButtonBox button div:lang(fa) {\r\n        margin-left: 25px;\r\n    }\r\n    .ProjctsButtonBox button div p {\r\n        font-size: 20px;\r\n    }\r\n    .ProjctsButtonBox button p {\r\n        margin-top: 0;\r\n        font-size: 30px;\r\n        margin-left: 536px;\r\n    }\r\n\r\n    .ProjectsTittleBox {\r\n        margin-top: 50px;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .GreenJournalBox button {\r\n        width: 100%;\r\n        height: 80px;\r\n        margin-top: 100px;\r\n        max-width: 1340px;\r\n    }\r\n    .GreenJournalBox button p {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .GreenJournalInfoBox {\r\n        width: 100%;\r\n        height: 500px;\r\n        overflow: hidden;\r\n        margin-top: 50px;\r\n        max-width: 1140px;\r\n        text-align: right;\r\n        border-radius: 30px;\r\n        vertical-align: top;\r\n        display: inline-block;\r\n        float: none !important;\r\n        border-top-left-radius: 50px;\r\n        border-top-right-radius: 0px;\r\n    }\r\n    .GreenJournalInfoBox p {\r\n        font-size: 30px;\r\n        margin-left: 50px;\r\n    }\r\n\r\n    .GreenJournalBoxHeader {\r\n        height: 150px;\r\n        border-top-left-radius: 50px;\r\n        border-bottom-right-radius: 50px;\r\n    }\r\n\r\n    .StoryBox {\r\n        width: 100px;\r\n        height: 100px;\r\n        overflow: hidden;\r\n        margin-top: 20px;\r\n        margin-right: 30px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n\r\n    .SlideShapeButton {\r\n        width: 40px;\r\n        height: 40px;\r\n        margin-top: 55px;\r\n    }\r\n\r\n    .GreenJournalBoxHeaderTextAndSlideBox p {\r\n        font-size: 40px;\r\n        margin-top: 53px;\r\n    }\r\n\r\n    .no_content_text {\r\n        font-size: 40px;\r\n        margin-top: 53px;\r\n    }\r\n\r\n    .about_barge_sabz_header_box button {\r\n        height: 80px;\r\n        margin-top: 100px;\r\n        max-width: 1340px;\r\n        margin-bottom: 50px;\r\n    }\r\n    .about_barge_sabz_header_box button p {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .about_barge_sabz_box img {\r\n        width: 100%;\r\n        height: 300px;\r\n        max-width: 1140px;\r\n        border-radius: 30px;\r\n        margin-bottom: -30px;\r\n    }\r\n\r\n    .about_barge_sabz_tittle_box button {\r\n        width: 100%;\r\n        height: 80px;\r\n        max-width: 700px;\r\n        position: relative;\r\n        border-radius: 100px;\r\n    }\r\n    .about_barge_sabz_tittle_box button p {\r\n        font-size: 30px;   \r\n    }\r\n\r\n    .about_barge_sabz_body_box {\r\n        width: 100%;\r\n        height: 300px;\r\n        margin-top: -30px;\r\n        max-width: 1140px;\r\n        border-radius: 30px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n    .about_barge_sabz_body_box p {\r\n        font-size: 29px;\r\n        margin-top: 70px;\r\n    }\r\n\r\n    .contact_us_header_box button {\r\n        width: 100%;\r\n        height: 80px;\r\n        margin-top: 50px;\r\n        max-width: 1340px;\r\n        margin-bottom: 50px;\r\n    }\r\n    .contact_us_header_box button p {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .contact_icon_box {\r\n        width: 100%;\r\n        height: 130px;\r\n        max-width: 320px;\r\n        margin-left: 50px;\r\n        border-radius: 100px;\r\n        float: left !important;\r\n        border: 1px solid #D6E5B8;\r\n    }\r\n    .contact_icon_box img {\r\n        width: 70px;\r\n        float: left;\r\n        height: 70px;\r\n        margin-top: 30px;\r\n        margin-left: 30px;\r\n    }\r\n\r\n    .email_icon {\r\n        width: 60px !important;\r\n        height: 60px !important;\r\n    }\r\n\r\n    .contact_id_box {\r\n        width: 100%;\r\n        height: 70px;\r\n        max-width: 450px;\r\n        margin-top: 30px;\r\n        margin-left: 140px;\r\n        border-radius: 100px;\r\n    }\r\n    .contact_id_box p {\r\n        font-size: 30px;\r\n        color: #FFFFFF;\r\n    }\r\n\r\n    .email_text {\r\n        font-size: 28px !important;\r\n    }\r\n\r\n    .ServicesBoxFrame {\r\n        scroll-margin-top: 300px;\r\n    }\r\n\r\n    .about_barge_sabz_header_box {\r\n        scroll-margin-top: 110px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"IntroductionBox": `landing-page_IntroductionBox__ztyBm`,
	"ServicesBox": `landing-page_ServicesBox__yOiI1`,
	"ServicesBoxFrame": `landing-page_ServicesBoxFrame__iggPn`,
	"PlantsButtonBox": `landing-page_PlantsButtonBox__uPTSx`,
	"PlantsBox": `landing-page_PlantsBox__kWGsV`,
	"ProjctsButtonBox": `landing-page_ProjctsButtonBox__jnxfl`,
	"ProjectsTittleBox": `landing-page_ProjectsTittleBox__tQ9fF`,
	"ProjectsPictureBox": `landing-page_ProjectsPictureBox__AeOZd`,
	"GreenJournalBox": `landing-page_GreenJournalBox__h6Ygk`,
	"GreenJournalInfoBox": `landing-page_GreenJournalInfoBox__O6bPE`,
	"GreenJournalBoxHeader": `landing-page_GreenJournalBoxHeader__6sTjL`,
	"StoryBox": `landing-page_StoryBox__GDuoh`,
	"GreenJournalBoxHeaderTextAndSlideBox": `landing-page_GreenJournalBoxHeaderTextAndSlideBox__T-22g`,
	"no_content_text": `landing-page_no_content_text__wHrUD`,
	"SlideShapeButton": `landing-page_SlideShapeButton__Db3+q`,
	"about_barge_sabz_box": `landing-page_about_barge_sabz_box__iJrQE`,
	"about_barge_sabz_header_box": `landing-page_about_barge_sabz_header_box__SXVjB`,
	"about_barge_sabz_tittle_box": `landing-page_about_barge_sabz_tittle_box__II+C4`,
	"about_barge_sabz_body_box": `landing-page_about_barge_sabz_body_box__aCoU6`,
	"contact_us_box": `landing-page_contact_us_box__udSGp`,
	"contact_us_header_box": `landing-page_contact_us_header_box__SS48q`,
	"contact_id_box": `landing-page_contact_id_box__PLtsS`,
	"contact_icon_box": `landing-page_contact_icon_box__OEKH3`,
	"services_button_box": `landing-page_services_button_box__EhPNY`,
	"email_text": `landing-page_email_text__Zatu1`,
	"email_icon": `landing-page_email_icon__BIZCZ`,
	"header_box": `landing-page_header_box__xE66y`
};
export default ___CSS_LOADER_EXPORT___;
